import axios from "axios";
import { FETCH_BATTERY_TABLE, HANDLE_ERRORS, LOADING_MODE } from "./types";
import BASE_URL from '../helpers/base-url';
import authorizeRequest from "../helpers/authorize-request";

export const getTableBatteryInfo = () => async dispatch => {
  try {
    dispatch({ type: LOADING_MODE, payload: true, meta: { type: 'batteryStatus' } });
    const response = await axios.get(`${BASE_URL}/api/file/battery`, authorizeRequest());

    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: "", open: false }
    });
    await dispatch({
      type: FETCH_BATTERY_TABLE,
      payload: response
    });
    dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'batteryStatus' } });
  } catch (error) {
    console.error("error fetching battery info for table", error);
    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: error.message, open: true }
    });
    dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'batteryStatus' } });
  }
};



// WEBPACK FOOTER //
// ./src/actions/getTableBatteryInfo.js